
import { Course } from '../types';

export const representing_yourself: Course = {
  id: "representing_yourself",
  title: "Representing Yourself",
  description: "Being a Litigant in Person (LIP). Tips on bundles and etiquette.",
  icon: "🗣️",
  totalModules: 11,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/representing_yourself/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/representing_yourself/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/representing_yourself/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/representing_yourself/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/representing_yourself/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/representing_yourself/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/representing_yourself/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/representing_yourself/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/representing_yourself/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/representing_yourself/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/representing_yourself/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "Which of the following actions is NOT generally permitted for a McKenzie Friend during a family court hearing?",
        "o": [
            "Taking detailed notes during the hearing.",
            "Quietly whispering advice to you.",
            "Speaking on your behalf to the judge.",
            "Helping you organise documents before the hearing."
        ],
        "a": 2
    },
    {
        "q": "According to the course, what is the correct protocol when the judge enters the courtroom?",
        "o": [
            "Remain seated and make eye contact with the judge.",
            "Stand immediately and wait for the judge to instruct you to sit.",
            "Nod politely and prepare your documents.",
            "Greet the judge with 'Your Honour' regardless of their court type."
        ],
        "a": 1
    },
    {
        "q": "What are the two mandatory requirements for compiling the Court Bundle?",
        "o": [
            "It must be spiral-bound and color-coded.",
            "It must be paginated and include a clear index.",
            "It must be submitted electronically and in hard copy.",
            "It must be prepared by a legal professional and signed by the judge."
        ],
        "a": 1
    },
    {
        "q": "What is the primary benefit of adhering to 'The Don't Bite Rule' when the other party says something untrue?",
        "o": [
            "It demonstrates your legal expertise by correcting inaccuracies immediately.",
            "It saves time during the hearing by preventing long arguments.",
            "It makes you appear calm, highly organized, and credible to the judge.",
            "It ensures the opposing party can fully present their case without interruption."
        ],
        "a": 2
    },
    {
        "q": "How should a Litigant in Person address a District Judge in family court?",
        "o": [
            "Your Honour",
            "Sir or Madam",
            "Judge [Last Name]",
            "Your Excellency"
        ],
        "a": 1
    }
]
};
